module.exports = __webpack_public_path__ + "static/img/star.91c10562.svg";